import React, { useEffect, useState } from "react";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { Paper, makeStyles, useMediaQuery } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { useUserAddress } from "eth-hooks";
import { ethers } from "ethers";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import ls from "local-storage";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AuctionPage from "./Pages/Auction/AuctionPage";
import ClaimPage from "./Pages/Claim/ClaimPage";
import toggleDark from "./assets/toggleDark.png";
import votBox40 from "./assets/votBox40.png";
import votBox56 from "./assets/votBox56.png";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import MobileHeader from "./components/Header/MobileHeader";
import theme from "./components/Theme";
import {
  NETWORKS,
  auctionABI,
  auctionAddress,
  crvABI,
  crvAddress,
} from "./constants";
import {
  getActiveProposal,
  getDelegateAddress,
} from "./scripts/scripts";

//web3onboard:
import coinbaseWalletModule from "@web3-onboard/coinbase";
import gnosisModule from "@web3-onboard/gnosis";
import injectedModule from "@web3-onboard/injected-wallets/";
import { init, useConnectWallet } from "@web3-onboard/react";
import walletConnectModule from "@web3-onboard/walletconnect";
import frameModule from "@web3-onboard/frame";

const readProvider = new ethers.providers.JsonRpcProvider(
  NETWORKS.mainnet.rpcUrl
);

const apiKey = "f8c1cda2-a22e-450a-b5a4-796aad6013ae";
const injected = injectedModule();
const rpcUrl = NETWORKS.mainnet.rpcUrl;
const walletConnect = walletConnectModule({
  projectId: "1a07a069e30a07b437bcef114b700cfb", // ***New Param* Project ID associated with [WalletConnect account](https://cloud.walletconnect.com)
  dappUrl: "https://votium.app",
});
const gnosis = gnosisModule();
const coinbaseWalletSdk = coinbaseWalletModule({ darkMode: true });
const frame = frameModule();

const appMetadata = {
  name: "Votium",
  icon: votBox40,
  logo: votBox56,
  description: "My app using Onboard",
  recommendedInjectedWallets: [
    { name: "Coinbase", url: "https://wallet.coinbase.com/" },
    { name: "MetaMask", url: "https://metamask.io" },
  ],
};

// initialize Onboard
init({
  apiKey,
  connect: {
    autoConnectLastWallet: true,
  },
  theme: "dark",
  wallets: [injected, walletConnect, gnosis, coinbaseWalletSdk, frame],
  chains: [
    {
      id: "0x1",
      token: "ETH",
      label: "Ethereum Mainnet",
      rpcUrl,
    },
  ],
  appMetadata,
});

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB5m79DPiFl6lfBzEAIi4Es5frVjNdhA70",
  authDomain: "test-54f45.firebaseapp.com",
  databaseURL: "https://test-54f45-default-rtdb.firebaseio.com",
  projectId: "test-54f45",
  storageBucket: "test-54f45.appspot.com",
  messagingSenderId: "1041511688078",
  appId: "1:1041511688078:web:ac1873792d9f48463226df",
  measurementId: "G-WFSV46SNJF",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

const useStylesDark = makeStyles({
  background: {
    backgroundColor: "rgb(19, 20, 22)",
    backgroundRepeat: "repeat",
    height: "100%",
  },
  "@global": {
    body: {
      backgroundColor: "#3d4244",
    },
  },
  toggleDarkButton: {
    backgroundColor: "#888",
    borderRadius: "10px",
    position: "absolute",
    top: "2px",
    right: "2px",
    zIndex: "999",
    width: "30px",
    height: "30px",
    "&:hover": {
      backgroundColor: "#eee",
      cursor: "pointer",
    },
  },
});

const useStylesLight = makeStyles({
  background: {
    backgroundColor: "#F9FAFB",
    backgroundRepeat: "repeat",
    height: "100%",
  },
  "@global": {
    body: {
      backgroundColor: "#3d4244",
    },
  },
  toggleDarkButton: {
    backgroundColor: "#888",
    borderRadius: "10px",
    position: "absolute",
    top: "2px",
    right: "2px",
    zIndex: "999",
    width: "30px",
    height: "30px",
    "&:hover": {
      backgroundColor: "#eee",
      cursor: "pointer",
    },
  },
});

const scrollbarStyles = `
  :root {
    --onboard-modal-z-index: 1400;
  }

  ::-webkit-scrollbar {
    width: 12px;
  }
  
  ::-webkit-scrollbar-track {
    background-color: #1a1a1a;
  }
  
  ::-webkit-scrollbar-thumb {
    background-color: #444;
    border-radius: 6px;
  }
`;

function App() {
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  let provider;
  if (wallet) {
    provider = new ethers.providers.Web3Provider(wallet.provider, "any");
    // if using ethers v6 this is:
    // provider = new ethers.BrowserProvider(wallet.provider, 'any')
  }

  //mobile:
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const classesLight = useStylesLight();
  const classesDark = useStylesDark();
  if (ls.get("Mode") === null) {
    ls.set("Mode", "dark");
  }
  const [classes, setClasses] = useState(classesDark);
  const [ctheme, setTheme] = useState(ls.get("Mode"));
  const address = useUserAddress(provider);
  const [curveProposal, setCurveProposal] = useState(null);
  const [fxnProposal, setFxnProposal] = useState(null);
  const [delegateAddress, setDelegateAddress] = useState(undefined);

  const weenusContract = new ethers.Contract(crvAddress, crvABI, provider);

  const auctionContract = new ethers.Contract(
    auctionAddress,
    auctionABI,
    provider
  );

  const toggleTheme = () => {
    if (ctheme === "light") {
      console.log("dark");
      ls.set("Mode", "dark");
      setTheme("dark");
    } else {
      console.log("light");
      ls.set("Mode", "light");
      setTheme("light");
    }
  };

  useEffect(() => {
    if (ctheme === "light") {
      setClasses(classesLight);
    } else {
      setClasses(classesDark);
    }
  }, [ctheme]);

  // Delegation only changes when the connected account changes or after the
  // user submits a gauge-delegation tx (refreshDelegation). Key this on the
  // stable `address` string — NOT `provider`, which App recreates on every
  // render and would otherwise spam getDelegateAddress with redundant RPC calls.
  useEffect(() => {
    if (provider && address) {
      getDelegateAddress(address, provider).then(applyDelegation);
    } else if (!wallet) {
      setDelegateAddress(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  // getDelegateAddress returns a fresh { current, future } object each call;
  // preserve referential equality when the values are unchanged so a repeat
  // fetch (e.g. refreshDelegation) doesn't trigger a needless re-render.
  // On RPC failure ({ error: true }) keep the previous good state — never
  // overwrite with "not delegated".
  function applyDelegation(res) {
    setDelegateAddress((prev) => {
      if (!res || res.error) {
        return prev;
      }
      if (
        prev &&
        !prev.error &&
        prev.current === res.current &&
        prev.future === res.future
      ) {
        return prev;
      }
      return { current: res.current, future: res.future };
    });
  }

  const refreshDelegation = () => {
    if (provider && address) {
      getDelegateAddress(address, provider).then(applyDelegation);
    }
  };

  useEffect(() => {
    getActiveProposal("Curve", readProvider).then((p) => {
      if (p) setCurveProposal(p);
    });
    getActiveProposal("Fx", readProvider).then((p) => {
      if (p) setFxnProposal(p);
    });
  }, []);

  const renderAuctionRoute = (market, proposal) => (
    <div>
      <img
        className={classes.toggleDarkButton}
        src={toggleDark}
        onClick={toggleTheme}
      />
      {mobile ? (
        <MobileHeader
          provider={provider}
          connect={connect}
          disconnect={disconnect}
          wallet={wallet}
          address={address}
          contract={weenusContract}
          db={db}
          ctheme={ctheme}
          delegateAddress={delegateAddress}
          refreshDelegation={refreshDelegation}
          proposal={proposal}
        />
      ) : (
        <Header
          provider={provider}
          connect={connect}
          disconnect={disconnect}
          wallet={wallet}
          address={address}
          contract={weenusContract}
          db={db}
          ctheme={ctheme}
          delegateAddress={delegateAddress}
          refreshDelegation={refreshDelegation}
          proposal={proposal}
        />
      )}
      <AuctionPage
        provider={provider}
        contract={auctionContract}
        stakingContract={weenusContract}
        address={address}
        db={db}
        ctheme={ctheme}
        market={market}
        proposal={proposal}
        delegateAddress={delegateAddress}
        refreshDelegation={refreshDelegation}
        connect={connect}
      />
      <Footer ctheme={ctheme} provider={provider} address={address} />
    </div>
  );

  return (
    <ThemeProvider theme={theme}>
      <style>{scrollbarStyles}</style>
      <Paper className={classes.background} elevation={0}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Switch>
            <Route exact path="/yb" render={() => renderAuctionRoute("yb")} />
            <Route exact path="/fxn" render={() => renderAuctionRoute("fxn", fxnProposal)} />
            <Route
              exact
              path="/claim"
              render={() => (
                <div>
                  <img
                    className={classes.toggleDarkButton}
                    src={toggleDark}
                    onClick={toggleTheme}
                  />
                  {mobile ? (
                    <MobileHeader
                      provider={provider}
                      connect={connect}
                      disconnect={disconnect}
                      wallet={wallet}
                      address={address}
                      contract={weenusContract}
                      db={db}
                      ctheme={ctheme}
                      delegateAddress={delegateAddress}
                      refreshDelegation={refreshDelegation}
                    />
                  ) : (
                    <Header
                      provider={provider}
                      connect={connect}
                      disconnect={disconnect}
                      wallet={wallet}
                      address={address}
                      contract={weenusContract}
                      db={db}
                      ctheme={ctheme}
                      delegateAddress={delegateAddress}
                      refreshDelegation={refreshDelegation}
                    />
                  )}
                  <ClaimPage
                    provider={provider}
                    address={address}
                    contract={weenusContract}
                    db={db}
                    ctheme={ctheme}
                    delegateAddress={delegateAddress}
                    refreshDelegation={refreshDelegation}
                    connect={connect}
                  />
                  <Footer
                    provider={provider}
                    address={address}
                    ctheme={ctheme}
                  />
                </div>
              )}
            />
            <Route path="/" render={() => renderAuctionRoute(undefined, curveProposal)} />
          </Switch>
        </BrowserRouter>
      </Paper>
      <script src="/__/firebase/8.7.1/firebase-app.js"></script>

      <script src="/__/firebase/8.7.1/firebase-analytics.js"></script>

      <script src="/__/firebase/init.js"></script>
    </ThemeProvider>
  );
}

export default App;
